{
  "_comment": "Curated set of major constellations. Each entry has a name, optional IAU 3-letter abbreviation, an array of `stars` (J2000 right ascension + declination in degrees), an array of `lines` (pairs of indices into `stars`), and a `label` position (RA/Dec degrees) where the constellation name should render. Coordinates target the J2000 epoch and use the same inertial frame the BSC5 skybox cubemap is built against, so lines drawn here align with the visible star dots. Extending: append a new object below — the ConstellationLayer reads it at attach time and the JSON validator catches malformed entries before they reach the renderer.",
  "constellations": [
    {
      "name": "Orion",
      "abbrev": "Ori",
      "stars": [
        { "name": "Betelgeuse", "ra": 88.7929,  "dec":   7.4071 },
        { "name": "Bellatrix",  "ra": 81.2829,  "dec":   6.3497 },
        { "name": "Mintaka",    "ra": 83.0017,  "dec":  -0.2991 },
        { "name": "Alnilam",    "ra": 84.0534,  "dec":  -1.2019 },
        { "name": "Alnitak",    "ra": 85.1897,  "dec":  -1.9426 },
        { "name": "Saiph",      "ra": 86.9391,  "dec":  -9.6697 },
        { "name": "Rigel",      "ra": 78.6345,  "dec":  -8.2017 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 4], [4, 0], [4, 5], [2, 6]
      ],
      "label": { "ra": 83.5, "dec": -1.0 }
    },
    {
      "name": "Ursa Major",
      "abbrev": "UMa",
      "stars": [
        { "name": "Dubhe",  "ra": 165.9319, "dec": 61.7510 },
        { "name": "Merak",  "ra": 165.4600, "dec": 56.3825 },
        { "name": "Phecda", "ra": 178.4580, "dec": 53.6948 },
        { "name": "Megrez", "ra": 183.8567, "dec": 57.0326 },
        { "name": "Alioth", "ra": 193.5073, "dec": 55.9598 },
        { "name": "Mizar",  "ra": 200.9814, "dec": 54.9254 },
        { "name": "Alkaid", "ra": 206.8852, "dec": 49.3133 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 0], [3, 4], [4, 5], [5, 6]
      ],
      "label": { "ra": 185.0, "dec": 56.0 }
    },
    {
      "name": "Ursa Minor",
      "abbrev": "UMi",
      "stars": [
        { "name": "Polaris", "ra":  37.954, "dec": 89.264 },
        { "name": "Yildun",  "ra": 263.054, "dec": 86.586 },
        { "name": "Epsilon", "ra": 251.493, "dec": 82.037 },
        { "name": "Zeta",    "ra": 236.014, "dec": 77.794 },
        { "name": "Eta",     "ra": 244.376, "dec": 75.755 },
        { "name": "Kochab",  "ra": 222.676, "dec": 74.156 },
        { "name": "Pherkad", "ra": 230.182, "dec": 71.834 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 4], [4, 6], [6, 5], [5, 3], [3, 2]
      ],
      "label": { "ra": 245.0, "dec": 80.0 }
    },
    {
      "name": "Cassiopeia",
      "abbrev": "Cas",
      "stars": [
        { "name": "Caph",    "ra":  2.2950, "dec": 59.1500 },
        { "name": "Schedar", "ra": 10.1268, "dec": 56.5373 },
        { "name": "Gamma",   "ra": 14.1772, "dec": 60.7167 },
        { "name": "Ruchbah", "ra": 21.4538, "dec": 60.2353 },
        { "name": "Segin",   "ra": 28.5988, "dec": 63.6702 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 4]
      ],
      "label": { "ra": 12.5, "dec": 64.0 }
    },
    {
      "name": "Cygnus",
      "abbrev": "Cyg",
      "stars": [
        { "name": "Deneb",   "ra": 310.358, "dec": 45.280 },
        { "name": "Sadr",    "ra": 305.557, "dec": 40.257 },
        { "name": "Gienah",  "ra": 311.553, "dec": 33.970 },
        { "name": "Delta",   "ra": 296.244, "dec": 45.131 },
        { "name": "Albireo", "ra": 292.680, "dec": 27.960 }
      ],
      "lines": [
        [0, 1], [1, 4], [3, 1], [1, 2]
      ],
      "label": { "ra": 305.0, "dec": 47.0 }
    },
    {
      "name": "Lyra",
      "abbrev": "Lyr",
      "stars": [
        { "name": "Vega",     "ra": 279.235, "dec": 38.784 },
        { "name": "Epsilon",  "ra": 281.085, "dec": 39.670 },
        { "name": "Zeta",     "ra": 281.193, "dec": 37.605 },
        { "name": "Sheliak",  "ra": 282.520, "dec": 33.363 },
        { "name": "Sulafat",  "ra": 284.736, "dec": 32.689 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 4], [4, 2]
      ],
      "label": { "ra": 281.0, "dec": 41.0 }
    },
    {
      "name": "Aquila",
      "abbrev": "Aql",
      "stars": [
        { "name": "Altair",   "ra": 297.696, "dec":  8.868 },
        { "name": "Tarazed",  "ra": 296.565, "dec": 10.613 },
        { "name": "Alshain",  "ra": 298.828, "dec":  6.407 },
        { "name": "Zeta",     "ra": 286.354, "dec": 13.864 },
        { "name": "Theta",    "ra": 302.826, "dec": -0.821 }
      ],
      "lines": [
        [1, 0], [0, 2], [0, 3], [0, 4]
      ],
      "label": { "ra": 297.0, "dec": 12.5 }
    },
    {
      "name": "Boötes",
      "abbrev": "Boo",
      "stars": [
        { "name": "Arcturus", "ra": 213.915, "dec": 19.182 },
        { "name": "Rho",      "ra": 217.957, "dec": 30.371 },
        { "name": "Seginus",  "ra": 218.020, "dec": 38.308 },
        { "name": "Nekkar",   "ra": 225.487, "dec": 40.391 },
        { "name": "Delta",    "ra": 228.876, "dec": 33.315 },
        { "name": "Izar",     "ra": 221.247, "dec": 27.074 }
      ],
      "lines": [
        [0, 5], [5, 4], [4, 3], [3, 2], [2, 1], [1, 0]
      ],
      "label": { "ra": 222.0, "dec": 32.0 }
    },
    {
      "name": "Scorpius",
      "abbrev": "Sco",
      "stars": [
        { "name": "Antares", "ra": 247.352, "dec": -26.432 },
        { "name": "Graffias","ra": 241.359, "dec": -19.806 },
        { "name": "Dschubba","ra": 240.083, "dec": -22.622 },
        { "name": "Pi",      "ra": 239.713, "dec": -26.114 },
        { "name": "Sigma",   "ra": 245.297, "dec": -25.593 },
        { "name": "Tau",     "ra": 248.971, "dec": -28.216 },
        { "name": "Epsilon", "ra": 252.541, "dec": -34.293 },
        { "name": "Mu",      "ra": 253.499, "dec": -38.018 },
        { "name": "Zeta",    "ra": 254.418, "dec": -42.362 },
        { "name": "Eta",     "ra": 258.038, "dec": -43.239 },
        { "name": "Shaula",  "ra": 263.402, "dec": -37.104 },
        { "name": "Sargas",  "ra": 264.330, "dec": -42.998 }
      ],
      "lines": [
        [1, 2], [2, 3], [3, 4], [4, 0], [0, 5], [5, 6], [6, 7], [7, 8], [8, 9], [9, 11], [11, 10]
      ],
      "label": { "ra": 250.0, "dec": -30.0 }
    },
    {
      "name": "Sagittarius",
      "abbrev": "Sgr",
      "stars": [
        { "name": "Kaus Australis", "ra": 276.043, "dec": -34.385 },
        { "name": "Kaus Media",     "ra": 275.249, "dec": -29.828 },
        { "name": "Kaus Borealis",  "ra": 276.993, "dec": -25.421 },
        { "name": "Phi",            "ra": 279.461, "dec": -26.991 },
        { "name": "Nunki",          "ra": 283.816, "dec": -26.297 },
        { "name": "Tau",            "ra": 286.738, "dec": -27.670 },
        { "name": "Ascella",        "ra": 285.653, "dec": -29.880 }
      ],
      "lines": [
        [0, 1], [1, 2], [0, 6], [1, 3], [3, 4], [4, 5], [5, 6], [2, 3]
      ],
      "label": { "ra": 281.0, "dec": -32.0 }
    },
    {
      "name": "Leo",
      "abbrev": "Leo",
      "stars": [
        { "name": "Regulus",   "ra": 152.093, "dec":  11.967 },
        { "name": "Eta",       "ra": 151.834, "dec":  16.763 },
        { "name": "Algieba",   "ra": 154.993, "dec":  19.842 },
        { "name": "Adhafera",  "ra": 154.173, "dec":  23.417 },
        { "name": "Rasalas",   "ra": 146.463, "dec":  26.007 },
        { "name": "Epsilon",   "ra": 146.463, "dec":  23.774 },
        { "name": "Zosma",     "ra": 168.527, "dec":  20.524 },
        { "name": "Denebola",  "ra": 177.265, "dec":  14.572 },
        { "name": "Chort",     "ra": 168.560, "dec":  15.430 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 1], [2, 6], [6, 7], [7, 8], [8, 0]
      ],
      "label": { "ra": 160.0, "dec": 22.0 }
    },
    {
      "name": "Virgo",
      "abbrev": "Vir",
      "stars": [
        { "name": "Spica",        "ra": 201.298, "dec": -11.161 },
        { "name": "Zavijava",     "ra": 177.674, "dec":   1.764 },
        { "name": "Porrima",      "ra": 190.415, "dec":  -1.449 },
        { "name": "Vindemiatrix", "ra": 195.544, "dec":  10.959 },
        { "name": "Heze",         "ra": 203.673, "dec":  -0.595 },
        { "name": "Delta",        "ra": 193.901, "dec":   3.398 }
      ],
      "lines": [
        [0, 4], [4, 3], [3, 5], [5, 2], [2, 1], [4, 2]
      ],
      "label": { "ra": 195.0, "dec":  -5.0 }
    },
    {
      "name": "Taurus",
      "abbrev": "Tau",
      "stars": [
        { "name": "Aldebaran", "ra": 68.980, "dec": 16.509 },
        { "name": "Gamma",     "ra": 64.948, "dec": 15.628 },
        { "name": "Epsilon",   "ra": 67.154, "dec": 19.180 },
        { "name": "Lambda",    "ra": 60.170, "dec": 12.490 },
        { "name": "Elnath",    "ra": 81.573, "dec": 28.608 },
        { "name": "Zeta",      "ra": 84.411, "dec": 21.143 }
      ],
      "lines": [
        [0, 1], [1, 3], [1, 2], [2, 4], [0, 5]
      ],
      "label": { "ra": 70.0, "dec": 22.0 }
    },
    {
      "name": "Gemini",
      "abbrev": "Gem",
      "stars": [
        { "name": "Castor",   "ra": 113.650, "dec": 31.889 },
        { "name": "Pollux",   "ra": 116.329, "dec": 28.026 },
        { "name": "Alhena",   "ra":  99.428, "dec": 16.399 },
        { "name": "Mebsuta",  "ra": 100.983, "dec": 25.131 },
        { "name": "Tejat",    "ra":  95.740, "dec": 22.514 },
        { "name": "Wasat",    "ra": 110.031, "dec": 21.982 }
      ],
      "lines": [
        [0, 1], [0, 3], [3, 4], [1, 5], [5, 2]
      ],
      "label": { "ra": 109.0, "dec": 30.0 }
    },
    {
      "name": "Canis Major",
      "abbrev": "CMa",
      "stars": [
        { "name": "Sirius",    "ra": 101.287, "dec": -16.716 },
        { "name": "Mirzam",    "ra":  95.675, "dec": -17.956 },
        { "name": "Muliphein", "ra": 105.940, "dec": -15.633 },
        { "name": "Wezen",     "ra": 107.098, "dec": -26.393 },
        { "name": "Adhara",    "ra": 104.656, "dec": -28.972 },
        { "name": "Aludra",    "ra": 111.024, "dec": -29.303 },
        { "name": "Furud",     "ra":  95.078, "dec": -30.064 }
      ],
      "lines": [
        [1, 0], [0, 2], [2, 3], [3, 5], [3, 4], [4, 6]
      ],
      "label": { "ra": 105.0, "dec": -23.0 }
    },
    {
      "name": "Pegasus",
      "abbrev": "Peg",
      "stars": [
        { "name": "Markab",    "ra": 346.190, "dec": 15.205 },
        { "name": "Scheat",    "ra": 345.943, "dec": 28.083 },
        { "name": "Algenib",   "ra":   3.309, "dec": 15.184 },
        { "name": "Alpheratz", "ra":   2.097, "dec": 29.090 },
        { "name": "Enif",      "ra": 326.046, "dec":  9.875 },
        { "name": "Homam",     "ra": 340.367, "dec": 10.832 },
        { "name": "Matar",     "ra": 340.751, "dec": 30.221 }
      ],
      "lines": [
        [0, 1], [1, 3], [3, 2], [2, 0], [1, 6], [6, 4], [0, 5]
      ],
      "label": { "ra": 350.0, "dec": 20.0 }
    },
    {
      "name": "Andromeda",
      "abbrev": "And",
      "stars": [
        { "name": "Alpheratz", "ra":   2.097, "dec": 29.090 },
        { "name": "Delta",     "ra":   9.832, "dec": 30.861 },
        { "name": "Mirach",    "ra":  17.433, "dec": 35.621 },
        { "name": "Mu",        "ra":  14.188, "dec": 38.499 },
        { "name": "Almach",    "ra":  30.975, "dec": 42.330 },
        { "name": "Nu",        "ra":  12.453, "dec": 41.079 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 4], [2, 3], [3, 5]
      ],
      "label": { "ra": 17.0, "dec": 39.0 }
    },
    {
      "name": "Aries",
      "abbrev": "Ari",
      "stars": [
        { "name": "Hamal",      "ra": 31.793, "dec": 23.462 },
        { "name": "Sheratan",   "ra": 28.660, "dec": 20.808 },
        { "name": "Mesarthim",  "ra": 28.389, "dec": 19.294 }
      ],
      "lines": [
        [0, 1], [1, 2]
      ],
      "label": { "ra": 31.0, "dec": 26.0 }
    },
    {
      "name": "Perseus",
      "abbrev": "Per",
      "stars": [
        { "name": "Mirfak",  "ra": 51.081, "dec": 49.861 },
        { "name": "Gamma",   "ra": 46.196, "dec": 53.506 },
        { "name": "Eta",     "ra": 42.674, "dec": 55.895 },
        { "name": "Delta",   "ra": 55.732, "dec": 47.788 },
        { "name": "Epsilon", "ra": 59.463, "dec": 40.010 },
        { "name": "Zeta",    "ra": 58.533, "dec": 31.884 },
        { "name": "Algol",   "ra": 47.042, "dec": 40.956 }
      ],
      "lines": [
        [2, 1], [1, 0], [0, 3], [3, 4], [4, 5], [0, 6]
      ],
      "label": { "ra": 52.0, "dec": 46.0 }
    },
    {
      "name": "Hercules",
      "abbrev": "Her",
      "stars": [
        { "name": "Ras Algethi",  "ra": 258.662, "dec": 14.390 },
        { "name": "Kornephoros",  "ra": 247.555, "dec": 21.490 },
        { "name": "Gamma",        "ra": 244.934, "dec": 19.153 },
        { "name": "Delta",        "ra": 258.762, "dec": 24.839 },
        { "name": "Epsilon",      "ra": 255.072, "dec": 30.926 },
        { "name": "Zeta",         "ra": 250.323, "dec": 31.602 },
        { "name": "Eta",          "ra": 250.722, "dec": 38.922 },
        { "name": "Pi",           "ra": 258.762, "dec": 36.809 }
      ],
      "lines": [
        [0, 3], [3, 5], [3, 4], [4, 7], [7, 6], [6, 5], [5, 1], [1, 2]
      ],
      "label": { "ra": 255.0, "dec": 28.0 }
    },
    {
      "name": "Draco",
      "abbrev": "Dra",
      "stars": [
        { "name": "Eltanin",  "ra": 269.152, "dec": 51.489 },
        { "name": "Rastaban", "ra": 262.608, "dec": 52.301 },
        { "name": "Nu",       "ra": 263.054, "dec": 55.185 },
        { "name": "Xi",       "ra": 268.382, "dec": 56.873 },
        { "name": "Zeta",     "ra": 257.197, "dec": 65.715 },
        { "name": "Eta",      "ra": 245.931, "dec": 61.514 },
        { "name": "Iota",     "ra": 231.232, "dec": 58.966 },
        { "name": "Thuban",   "ra": 211.097, "dec": 64.376 },
        { "name": "Chi",      "ra": 268.626, "dec": 65.563 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 0], [3, 4], [4, 5], [5, 6], [6, 7], [4, 8]
      ],
      "label": { "ra": 240.0, "dec": 64.0 }
    },
    {
      "name": "Aquarius",
      "abbrev": "Aqr",
      "stars": [
        { "name": "Sadalsuud",   "ra": 322.890, "dec":  -5.571 },
        { "name": "Sadalmelik",  "ra": 331.446, "dec":  -0.320 },
        { "name": "Gamma",       "ra": 339.290, "dec":  -1.387 },
        { "name": "Zeta",        "ra": 337.708, "dec":  -0.019 },
        { "name": "Eta",         "ra": 342.410, "dec":  -0.118 },
        { "name": "Skat",        "ra": 343.663, "dec": -15.821 }
      ],
      "lines": [
        [0, 1], [1, 3], [3, 2], [3, 4], [4, 5]
      ],
      "label": { "ra": 333.0, "dec":  -8.0 }
    },
    {
      "name": "Hydra",
      "abbrev": "Hya",
      "stars": [
        { "name": "Sigma",   "ra": 127.566, "dec":   3.342 },
        { "name": "Eta",     "ra": 131.685, "dec":   3.399 },
        { "name": "Delta",   "ra": 132.107, "dec":   5.704 },
        { "name": "Epsilon", "ra": 134.649, "dec":   6.420 },
        { "name": "Zeta",    "ra": 132.633, "dec":   5.946 },
        { "name": "Alphard", "ra": 141.897, "dec":  -8.659 },
        { "name": "Nu",      "ra": 162.992, "dec": -16.193 },
        { "name": "Gamma",   "ra": 199.730, "dec": -23.171 },
        { "name": "Pi",      "ra": 219.916, "dec": -26.682 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 4], [4, 0], [4, 5], [5, 6], [6, 7], [7, 8]
      ],
      "label": { "ra": 160.0, "dec": -13.0 }
    },
    {
      "name": "Centaurus",
      "abbrev": "Cen",
      "stars": [
        { "name": "Rigil Kentaurus", "ra": 219.920, "dec": -60.834 },
        { "name": "Hadar",           "ra": 210.956, "dec": -60.373 },
        { "name": "Epsilon",         "ra": 204.972, "dec": -53.466 },
        { "name": "Zeta",            "ra": 217.794, "dec": -47.289 },
        { "name": "Gamma",           "ra": 190.379, "dec": -48.960 },
        { "name": "Delta",           "ra": 182.090, "dec": -50.722 },
        { "name": "Menkent",         "ra": 211.671, "dec": -36.370 },
        { "name": "Iota",            "ra": 200.489, "dec": -36.712 },
        { "name": "Birdun",          "ra": 218.876, "dec": -42.158 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [2, 4], [4, 5], [3, 8], [8, 6], [6, 7]
      ],
      "label": { "ra": 207.0, "dec": -47.0 }
    },
    {
      "name": "Carina",
      "abbrev": "Car",
      "stars": [
        { "name": "Canopus",     "ra":  95.988, "dec": -52.696 },
        { "name": "Avior",       "ra": 125.628, "dec": -59.510 },
        { "name": "Aspidiske",   "ra": 139.273, "dec": -59.275 },
        { "name": "Miaplacidus", "ra": 138.300, "dec": -69.717 },
        { "name": "Theta",       "ra": 160.739, "dec": -64.394 },
        { "name": "Omega",       "ra": 156.061, "dec": -70.038 }
      ],
      "lines": [
        [0, 1], [1, 2], [2, 3], [3, 5], [5, 4], [4, 2]
      ],
      "label": { "ra": 130.0, "dec": -62.0 }
    },
    {
      "name": "Crux",
      "abbrev": "Cru",
      "stars": [
        { "name": "Acrux",    "ra": 186.650, "dec": -63.099 },
        { "name": "Mimosa",   "ra": 191.930, "dec": -59.689 },
        { "name": "Gacrux",   "ra": 187.791, "dec": -57.113 },
        { "name": "Imai",     "ra": 183.786, "dec": -58.749 }
      ],
      "lines": [
        [0, 2], [1, 3]
      ],
      "label": { "ra": 187.5, "dec": -56.0 }
    }
  ]
}
